const varDefaults = {
  subject: [
    {
      key: 'tenantName',
      value: '{{accountName}}',
    },
  ],
  body: [
    {
      key: 'tenantName',
      value: '#{accountName}',
    },
    {
      key: 'userFirstName',
      value: '#{user.firstName}',
    },
    {
      key: 'userLastName',
      value: '#{user.lastName}',
    },
  ],
};

export const templateLocals = {
  // keep siteName around for templates that still use
  // siteName, but it was replaced with tenantName
  siteName: 'Account-Name',
  siteUrl: 'https://domain.example.com',
  accountName: 'Account-Name',
  // remove when all templates are update to use `accountName`
  tenantName: 'Account-Name',
  bridge: {
    name: 'Name of connector',
  },
  bridgeError: '>>Errormessage here<<',
  user: {
    firstName: 'Firstname',
    lastName: 'Lastname',
  },
  accessEntity: {
    title: 'AccessEntity Titel',
  },
  token: 'w75R076A0oa6pSpzJVI54p.QfiE3ZyMWc0pXMj92dzEWcjBjY0NHMkRjbqNmI6ISYiwiIvRmbv1WanlGZiojI1Jye',
  ipAddress: '127.0.0.1',
};

export const templateVariables = {
  isFmAccessCreated: {
    subject: [
      ...varDefaults.subject,
      {
        key: 'accessEntityTitle',
        value: '{{accessEntity.title}}',
      },
    ],
    body: [
      ...varDefaults.body,
      {
        key: 'accessEntityTitle',
        value: '#{accessEntity.title}',
      },
    ],
  },
  isFmAccessRevoked: {
    subject: [
      ...varDefaults.subject,
      {
        key: 'accessEntityTitle',
        value: '{{accessEntity.title}}',
      },
    ],
    body: [
      ...varDefaults.body,
      {
        key: 'accessEntityTitle',
        value: '#{accessEntity.title}',
      },
    ],
  },
  passwordChanged: {
    subject: [...varDefaults.subject],
    body: [...varDefaults.body],
  },
  passwordReset: {
    subject: [...varDefaults.subject],
    body: [
      ...varDefaults.body,
      {
        key: 'pwdResetLinkHref',
        value: 'siteUrl+"/#/change-password?token=" + token',
      },
      {
        key: 'pwdResetLinkText',
        value: '#{siteUrl}/#/change-password?token=#{token}',
      },
    ],
  },
  tenantBridgeConnectionerror: {
    subject: [
      ...varDefaults.subject,
      {
        key: 'bridgeName',
        value: '{{bridge.name}}',
      },
    ],
    body: [
      ...varDefaults.body,
      {
        key: 'bridgeName',
        value: '#{bridge.name}',
      },
      {
        key: 'bridgeError',
        value: '#{bridgeError}',
      },
    ],
  },
  ticketCreated: {
    subject: [...varDefaults.subject],
    body: [...varDefaults.body],
  },
  ticketCreatedManager: {
    subject: [...varDefaults.subject],
    body: [...varDefaults.body],
  },
  userCreatePasswordReset: {
    subject: [...varDefaults.subject],
    body: [
      ...varDefaults.body,
      {
        key: 'pwdResetLinkHref',
        value: 'siteUrl+"/#/change-password?token=" + token',
      },
      {
        key: 'pwdResetLinkText',
        value: '#{siteUrl}/#/change-password?token=#{token}',
      },
    ],
  },
  userLocked: {
    subject: [...varDefaults.subject],
    body: [
      ...varDefaults.body,
      {
        key: 'ipAddress',
        value: '#{ipAddress}',
      },
    ],
  },
};
